// extracted by mini-css-extract-plugin
module.exports = {"frame":"CreateAccountSuccessModal_frame__ewMHK"};